/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { CurrencyInfo } from '../models/CurrencyInfo';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class CurrencyService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns CurrencyInfo
     * @throws ApiError
     */
    public currencyGet(): Observable<Array<CurrencyInfo>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/currencies',
        });
    }
}
